@if (smallText) {
  <!-- M1 EMPTY -->
  <img *ngIf="icon" [src]="icon" />
  <div class="text" [class.small]="smallText">{{ text }}</div>
  <ng-content></ng-content>
} @else {
  <!-- M8 EMPTY -->
  <img src="assets/images/media/iconography/sample/empty-state.png" alt="Empty State" loading="lazy" />
  <div class="pubs-empty--title">{{ title }}</div>
  <div class="pubs-empty--message">{{ message }}</div>
}
